import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContextResolverService } from './core/resolvers/context-resolver.service';

const routes: Routes = [
  {
    path: 'cuenta-digital',
    loadChildren: () =>
      import('./context/context-cta-digital/context-cta-digital.module').then(
        (m) => m.ContextCtaDigitalModule
      ),
    resolve: { ContextResolverService },
  },
  {
    path: 'public',
    loadChildren: () =>
      import('./context/context-public/context-public.module').then(
        (m) => m.ContextPublicModule
      ),
    resolve: { ContextResolverService },
  },
  {
    path: '',
    redirectTo: 'public',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
